<template>
  <v-layout
    align-center
    justify-center
    class="mt-5 pt-5"
  >
    <v-flex
      xs10
      sm6
      md4
      text-xs-center
    >
      <v-card class="mt-5">
        <v-avatar color="primary">
          <v-icon
            color="white"
            large
          >
            local_shipping
          </v-icon>
        </v-avatar>
        <h2
          class="text-center mt-4"
          style="color: #1565C0"
        >
          Вход в систему
        </h2>
        <v-card-text>
          <v-form v-model="valid">
            <v-flex class="my-1">
              <v-text-field
                v-model="username"
                label="Имя пользователя"
                :rules="usernameRules"
                required
                outline
                height="44"
                @keyup.enter="submit"
              />
            </v-flex>
            <v-flex class="my-1">
              <v-text-field
                v-model="password"
                label="Пароль"
                :type="showPassword ? 'text' : 'password'"
                :rules="passwordRules"
                required
                outline
                height="44"
                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                autocomplete="new-password"
                @keyup.enter="submit"
                @click:append="showPassword = !showPassword"
              />
            </v-flex>
            <v-layout
              column
              class="mt-1"
            >
              <v-flex xs2>
                <v-btn
                  color="primary"
                  :disabled="!valid"
                  :loading="processedByServer"
                  @click="submit"
                >
                  Войти
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import auth from "./../auth";
import * as signInApi from "../backend/signInApi.js";

export default {
  data() {
    return {
      valid: false,
      username: "",
      usernameRules: [(v) => !!v || "Имя пользователя не может быть пустым"],
      password: "",
      passwordRules: [
        (v) => v.length >= 4 || "Пароль не может быть меньше 4-х символов",
      ],
      processedByServer: false,
      showPassword: false,
    };
  },
  methods: {
    async submit() {
      this.processedByServer = true;
      try {
        const response = await signInApi.signIn(this.username, this.password);

        auth.login(
          response.accessToken,
          response.refreshToken,
          response.expiresIn,
        );

        const userResponse = await signInApi.getCurrentUser();
        auth.setUser(userResponse);
        this.$router.push({ name: "home" });
        this.$emit("login");
        this.processedByServer = false;
      } catch (error) {
        this.processedByServer = false;
        this.showError("Некорректный логин/пароль");
      }
    },
  },
};
</script>

<style>
.login-logo {
  margin-top: 50px;
  margin-bottom: 50px;
}
</style>
